<form [formGroup]="addRuleFormGroup" (ngSubmit)="addButtonClick()">
    <div class="whole-modal">
        <div class="modal-header">
            <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center">
                    <h4 class="mb-0">
                    {{selectedRule?'Edit Rule':'Add New Rule'}}
                    </h4>
                    <a class="close-icon" href="javascript:void()" (click)="closeClick()" ngbAutofocus><i
                            class="flaticon2-cross"></i></a>
                </div>
            </div>

        </div>

        <div class="modal-body output-lable activity_body">
            <div class="inspection_form p-5">

                <div class="control-wrapper">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="label-wrap">
                                <mat-label class="font-style">Name</mat-label>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <input type="text" class="input-form-class" formControlName="name" matInput />

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer button-wrapper p-5">
            <button type="submit" class="btn primary-ebtn"
                [disabled]="!(addRuleFormGroup.valid && addRuleFormGroup.dirty )">{{selectedRule?'Save':'Add'}}</button>
            <button type="button" class="btn secondary-ebtn" (click)="closeClick()">Cancel</button>
        </div>
    </div>
</form>